import { IpexMomentEnum } from '@insights/insights-data-provider';
import { setLogger } from '@optimizely/react-sdk';
import { AnalyticsPayload } from 'analytics-api/AnalyticsEvent';
import AnalyticsService from 'analytics-api/AnalyticsService';
import { getExperiment } from 'optimizely/utils';
import { optimizelyInstance } from 'optimizely/OptimizelyProvider';
import { getUserId } from 'optimizely/utils';
import atMostOnce from 'utils/object-state/atMostOnce';
import waitFor from 'utils/object-state/waitFor';
import { getQuery } from 'utils/queryUtils';

const verboseAnalyticsLogging = getQuery().get('verboseAnalyticsLogging') === 'true';

if (!verboseAnalyticsLogging) {
  setLogger(null);
}

export default class OptimizelyService implements AnalyticsService {
  @atMostOnce
  async connect(): Promise<void> {
    const experiement = await getExperiment();

    if (experiement) {
      optimizelyInstance.activate(experiement.name, getUserId());
    }
  }

  @waitFor('connect')
  report(
    event: Readonly<{
      eventName: string;
      ipexMoment: IpexMomentEnum;
      payload: Readonly<AnalyticsPayload>;
    }>
  ): void {
    const datafileJSON = optimizelyInstance.getOptimizelyConfig()?.getDatafile();
    if (!datafileJSON) {
      return;
    }

    const datafile = JSON.parse(datafileJSON);
    if (!datafile) {
      return;
    }

    // The datafile contains all valid events, i.e events that are defined in Optimizely
    const events: string[] = datafile?.events?.map((event: any) => event.key);
    // If the event is not valid return. Otherwise it will log a warning
    if (!events.includes(event.eventName)) {
      return;
    }

    // When we want to track giveMe events but don't care about the exact event
    // we can send a 'give_me' event instead.
    if (event.ipexMoment === IpexMomentEnum.giveMe) {
      optimizelyInstance.track('give_me', getUserId(), {}, { event: event.eventName });
    }

    optimizelyInstance.track(event.eventName, getUserId());
  }
}
